  
<template>
  <div v-if="!requiredFields" class="red--text">
    <div>Merci de compléter les informations manquantes :</div>
    <ul>
      <li v-if="!park.firstname">Le prénom du demandeur</li>
      <li v-if="!park.lastname">Le nom du demandeur</li>
      <li v-if="!park.email">L'e-mail du demandeur</li>
      <li v-if="!park.unity">L'unité à laquelle le demandeur est rattaché</li>
      <li v-if="Object.keys(park.address).length === 0">L'adresse de domicile du demandeur</li>
      <li v-if="!park.registration">L'immatriculation du véhicule</li>
      <li v-if="park.children && !park.childrenReason">Les explications complémentaires pour enfant à charge</li>
      <li v-if="park.corporate && !park.corporateReason">Les explications complémentaires pour les déplacements professionnels fréquents</li>
      <li v-if="park.health && !park.healthDocument">L'attestation du médecin pour les raisons médicales</li>
      <li v-if="park.carpool && park.carpoolers.length === 0">Les personnes qui partageront le trajet pour le covoiturage</li>
      <li v-if="!park.acceptedPolicies">Prise de connaissance de la directive</li>
      <li v-if="!park.acceptedDataPolicies">Consentement pour l'accès aux données</li>
      <li v-if="!park.acceptedDataAccuracy">Confirmation de l'exactitude des données</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["park", 'requiredFields'],
};
</script>